export default "__VITE_ASSET__DCdQgCOg__"